import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/home/HomePage";
import { homeHead } from "@/components/home/home-head";
import { loadHome } from "@/components/home/home-loader";

// Главная на «/» — русская, канонический адрес русской версии. Язык по
// умолчанию угадывает autoLangRedirect в src/server.ts (до маршрутизации).
// Аналитика — общая из __root (analyticsHeadScripts + trackPageView), события
// главной (cta_click, мини-тест) — в HomePage.
export const Route = createFileRoute("/")({
  // Число стран для пина «за рубежом» и ссылки «Populyar» (29.10.2026). Сбой любой части — без неё.
  loader: () => loadHome("ru"),
  head: () => homeHead("ru"),
  component: function Page() {
    const data = Route.useLoaderData();
    return <HomePage lang="ru" countries={data.countries} popular={data.popular} />;
  },
});
